import { createContext } from "react";

export const LieuContext = createContext();
export const PuceContext = createContext();
export const LotPuceContext = createContext();
export const ImportUserContext = createContext();
export const AnimalContext99 = createContext();
export const CampagneInterventionContext = createContext();
export const InseminationContext = createContext();
export const InterventionContext = createContext();
export const LotInterventionContext = createContext();
export const LotIntrantContext = createContext();
export const MisebasContext = createContext();
export const ProduitMisebasContext = createContext();
export const SemenceContext = createContext();
